import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { ZuiShellBase } from './zui-shell-base.js';
import { style } from './zui-shell-content-actionbar-css.js';

/**
 * `<zui-shell-content-actionbar>` is to be inserted into `<zui-shell-content>` and functions well as a 'Builder' pattern.
 *
 * @slot - Default, unnamed slot; for inserting and placing `<zui-button>` elements into the right side of `<zui-shell-content-actionbar>`
 */
export class ZuiShellContentActionbar extends ZuiShellBase {
  /**
   * Header text that displays in the actionbar
   */
  @property({ type: String })
  header = '';

  constructor() {
    super();
    this._observePageScrollChange = true;
    this._observeBannerHeightChange = true;
  }

  static get styles() {
    return [super.styles, style];
  }

  connectedCallback() {
    super.connectedCallback();
    this._storeElement(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._removeElement(this);
  }

  render() {
    const styles = {
      top: `calc(${this._state.topBarHeight} + ${this._state.bannerHeight})`,
    };
    return html`
      <div class="actionbar-container" style=${styleMap(styles)}>
        <h2 class="text-container">${this.header}</h2>
        <div class="button-container">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

window.customElements.define('zui-shell-content-actionbar', ZuiShellContentActionbar);

declare global {
  interface HTMLElementTagNameMap {
    'zui-shell-content-actionbar': ZuiShellContentActionbar;
  }
}
